import { DtoApiPager } from "./abst/DtoApiPager";

export class DtoPaymentGetReq {
    //検索条件
    public claimNo_start: number | null = null;
    public claimNo_end: number | null = null;
    public ClaimDate_start: Date | null = null;
    public ClaimDate_end: Date | null = null;
    public Clientid: number | null = null;
    public ClaimTitle: string | null = null;
    public ClaimSponsorName: string | null = null;
    public ClaimPayLimit_start: Date | null = null;
    public ClaimPayLimit_end: Date | null = null;
    public StaffId: number | null = null;
    public PaymentStatus: number | null = null;

    public IsValidImple(chkPager: boolean): string[] {
        let res: string[] = new Array();

        let claimDateHasValue: boolean = false;
        let claimPayLimitHasValue: boolean = false;

        // 発行日が範囲入力されているか
        if (this.ClaimDate_start != null && this.ClaimDate_end != null) {
            claimDateHasValue = true;
        }
        // 入金予定日が範囲入力されているか
        if (this.ClaimPayLimit_start != null && this.ClaimPayLimit_end != null) {
            claimPayLimitHasValue = true;
        }
        if (!claimDateHasValue && !claimPayLimitHasValue) {
            res.push("発行日か入金予定日を3か月以内で指定してください。");
            return res;
        }

        let claimDateIs3Month: boolean = false;
        let claimPayLimitIs3Month: boolean = false;

        // 発行日が3か月以内で範囲指定されているかどうか
        if (this.ClaimDate_start != null && this.ClaimDate_end != null) {
            const start = new Date(this.ClaimDate_start);

            // 開始日の3か月後を計算
            const limit = new Date(start);
            limit.setMonth(limit.getMonth() + 3);

            // 3か月後 - 1日
            limit.setDate(limit.getDate() - 1);

            // 終了日が limit 以下ならOK
            if (new Date(this.ClaimDate_end) <= limit) {
                claimDateIs3Month = true;
            }
        }
        // 入金予定日が3か月以内で範囲指定されているかどうか
        if (this.ClaimPayLimit_start != null && this.ClaimPayLimit_end != null) {
            const start = new Date(this.ClaimPayLimit_start);

            // 開始日の3か月後を計算
            const limit = new Date(start);
            limit.setMonth(limit.getMonth() + 3);

            // 3か月後 - 1日
            limit.setDate(limit.getDate() - 1);

            // 終了日が limit 以下ならOK
            if (new Date(this.ClaimPayLimit_end) <= limit) {
                claimPayLimitIs3Month = true;
            }
        }
        if (!claimDateIs3Month && !claimPayLimitIs3Month) {
            res.push("発行日か入金予定日を3か月以内で指定してください。");
            return res;
        }

        return res;
    }

}